<template>
    <div class="container-fluid p-0 user-form-container">
        <!-- Header -->
        <div class="row m-0 p-3 gradient-background__noise text-white">
            <div class="col-12 text-center position-relative">
                <h5 class="m-0">
                    <ion-icon name="person" class="me-2"></ion-icon>
                    {{ dictionary['Nuevo usuario'][session.user.language] }}
                </h5>
                <div class="position-absolute end-0 top-0 pe-3 pt-1">
                    <ion-icon name="close" class="fs-4" @click="$router.back()"></ion-icon>
                </div>
            </div>
        </div>

        <!-- Success Message -->
        <div v-if="success" class="row m-0 justify-content-center align-items-center min-vh-100">
            <div class="col-11 col-sm-10 col-md-8 col-lg-6 col-xl-5 p-3 p-md-4">
                <div class="card p-3 p-md-4 bg-light shadow-sm border-0">
                    <div class="card-body text-center">
                        <div class="mb-3">
                            <ion-icon name="checkmark-circle" class="text-success"
                                style="font-size: 3.5rem;"></ion-icon>
                        </div>

                        <h4 class="text-success mb-3 fw-bold">
                            {{ dictionary['Solicitud enviada con éxito'][session.user.language] }}
                        </h4>
                        <div class="mb-3">
                            <p class="mb-2">
                                {{ dictionary['Una vez verificada se enviará un mensaje al correo electrónico'][session.user.language] }}
                            </p>
                            <p class="mb-0">
                                {{ dictionary['Muchas gracias'][session.user.language] }}
                            </p>
                        </div>
                        <div v-if="userData.email" class="bg-white rounded p-2 mb-3 border">
                            <small class="text-muted d-block">{{ dictionary['Correo electrónico'][session.user.language]
                                }}</small>
                            <strong class="text-break">{{ userData.email }}</strong>
                        </div>
                        <div class="mt-4">
                            <div class="progress" style="height: 6px;">
                                <div class="progress-bar bg-success" role="progressbar"
                                    :style="{ width: countdownProgress + '%' }" aria-valuenow="countdownProgress"
                                    aria-valuemin="0" aria-valuemax="100">
                                </div>
                            </div>
                            <small class="text-muted mt-2 d-block">
                                {{ dictionary['Redirigiendo...'][session.user.language] }}
                            </small>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Form Content -->
        <div v-else class="row m-0 justify-content-center form-content">
            <div class="col-12 col-lg-8 col-xl-6 p-3">
                <form class="needs-validation" novalidate>
                    <!-- Personal Data Section -->
                    <div class="mb-4">
                        <h6 class="text-muted mb-3 text-center">
                            <ion-icon name="person-circle" class="me-2"></ion-icon>
                            {{ dictionary['Datos personales'][session.user.language] }}
                        </h6>

                        <div class="row">
                            <!-- Name -->
                            <div class="col-12 col-md-6 mb-3 ">
                                <label for="inputName" class="form-label">
                                    {{ dictionary['Nombre'][session.user.language] }}
                                </label>
                                <input v-model="userData.name" type="text" class="form-control form-control-lg"
                                    style="color: black;" id="inputName" required>
                                <div class="invalid-feedback">
                                    {{ dictionary['Por favor ingrese su nombre'][session.user.language] }}
                                </div>
                            </div>

                            <!-- Last Name -->
                            <div class="col-12 col-md-6 mb-3 ">
                                <label for="inputLastName" class="form-label">
                                    {{ dictionary['Apellidos'][session.user.language] }}
                                </label>
                                <input v-model="userData.lastName" type="text" class="form-control form-control-lg "
                                    style="color: black;" id="inputLastName" required>
                                <div class="invalid-feedback">
                                    {{ dictionary['Por favor ingrese sus apellidos'][session.user.language] }}
                                </div>
                            </div>
                        </div>

                        <!-- Email -->
                        <div class="mb-3 ">
                            <label for="inputEmail" class="form-label">
                                {{ dictionary['Correo electrónico'][session.user.language] }}
                            </label>
                            <input v-model="userData.email" type="email" class="form-control form-control-lg "
                                style="color: black;" id="inputEmail" required>
                            <div class="invalid-feedback">
                                {{ dictionary['Por favor ingrese un email válido'][session.user.language] }}
                            </div>
                        </div>
                    </div>

                    <!-- Company/Address Section -->
                    <div class="mb-4 ">
                        <h6 class="text-muted mb-3 text-center">
                            <ion-icon name="business" class="me-2"></ion-icon>
                            {{ dictionary['Datos de la empresa'][session.user.language] }}
                        </h6>

                        <!-- Company (now as text input) -->
                        <div class="mb-3 ">
                            <label for="inputCompany" class="form-label">
                                {{ dictionary['Empresa'][session.user.language] }}
                            </label>
                            <input v-model="userData.adress2" type="text" class="form-control form-control-lg "
                                style="color: black;" id="inputCompany" required>
                            <div class="invalid-feedback">
                                {{ dictionary['Por favor introduce una empresa'][session.user.language] }}
                            </div>
                        </div>

                        <!-- Address -->
                        <div class="mb-3 ">
                            <label for="inputAddress" class="form-label">
                                {{ dictionary['Dirección'][session.user.language] }}
                            </label>
                            <textarea v-model="userData.adress1" class="form-control form-control-lg "
                                style="color: black;" id="inputAddress" rows="2" required></textarea>
                            <div class="invalid-feedback">
                                {{ dictionary['Por favor ingrese una dirección'][session.user.language] }}
                            </div>
                        </div>
                    </div>
                    <!-- CAPTCHA Section  -->
                    <div v-if="showCaptcha" class="row justify-content-center mb-3">
                        <div class="col-12 col-md-6">
                            <div class="card p-3 bg-light">
                                <h6 class="text-center mb-3 text-primary">
                                    <ion-icon name="shield-checkmark" class="me-2"></ion-icon>
                                    {{ dictionary['Verificación de seguridad'][session.user.language] }}
                                </h6>
                                <div class="text-center mb-2 fs-5">
                                    <strong>{{ captchaQuestion }}</strong>
                                </div>
                                <div class="d-flex align-items-center mb-3">
                                    <input v-model="captchaAnswer" type="number" class="form-control me-2"
                                        :placeholder="dictionary['Respuesta'][session.user.language]"
                                        @keyup.enter="verifyCaptcha">
                                    <button class="btn btn-primary" @click="verifyCaptcha" :disabled="!captchaAnswer">
                                        {{ dictionary['Verificar'][session.user.language] }}
                                    </button>
                                </div>
                                <div v-if="captchaError" class="text-center text-danger small">
                                    {{ dictionary['Respuesta incorrecta. Por favor intente nuevamente.'][session.user.language] }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Submit Button - Centered -->
                    <div v-if= "!showCaptcha" class="row justify-content-center mt-4">
                        <div class="col-12 col-md-6">
                            <button type="button" class="btn bg-clomos btn-lg w-100" @click="submitForm">
                                <ion-icon name="save" class="me-2"></ion-icon>
                                {{ dictionary['Solicitar alta'][session.user.language] }}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
            <!-- Pié -->
      <div class="row mt-5 pt-4 border-top border-black justify-content-around bg-light ">
        <div class="col-lg-3 col-12">
          <div class="mb-2">
            <img src="@/assets/img/logo-next-generation.png" title="Logo Next Generation EU"
              alt="Logo Next Generation EU" loading="lazy">
          </div>
        </div>
        <div class="col-lg-3 col-12">
          <div class="mb-2">
            <img src="@/assets/img/logo-mece-footer.png" title="logo-mece-footer" alt="logo-mece-footer" loading="lazy">
          </div>
        </div>
        <div class="col-lg-3 col-12">
          <div class="mb-2">
            <img src="@/assets/img/logo-PRTR.png" title="Logo Plan de Recuperación, Transformación y Resiliencia"
              alt="Logo Plan de Recuperación, Transformación y Resiliencia" loading="lazy">
          </div>
        </div>
        <div class="col-lg-3 col-12">
          <div class="mb-2">
            <img src="	https://aviles.es/image/layout_set_logo?img_id=40130&t=1739712231518"
              title="logo Diputación Foral de Alava" alt="logo Diputación Foral de Alava" loading="lazy">
          </div>
        </div>
      </div>
        </div>
    </div>
</template>

<script>
// Clomos
import api from '@/services/api';
export default {
    name: "NewRegisterUser",
    props: {
        session: {
            type: Object,
            required: true,
        },
        dictionary: {
            type: Object,
            required: true,
        }
    },
    data() {       
        const { question, solution } = this.generateCaptcha();
        return {
            userData: {
                name: "",
                lastName: "",
                email: "",
                nifCif: "P3300400C",
                adress1: "",
                adress2: "",
                language: this.$route.params.language != undefined ? this.$route.params.language : 'es',
                rol: "0",
                telephone: '',
                province: "Asturias",
                country: "ES",
                unitTemperature: "C",
                dateTimeZone: "Europe/Madrid",
                fieldSeparator: ";",
                dateTimeFormat: this.$route.params.language != undefined && this.$route.params.language == 'es' ? "DD/MM/YYYY" : "MM/DD/YYYY",
                authorisation: {
                    "modulosPermitidos": {
                        "smartLockers": {
                            "lockings": 1
                        }
                    }
                }
            },
            submitted: false,
            showCaptcha: false,
            captchaVerified: false,
            captchaQuestion: question,
            captchaSolution: solution,
            captchaAnswer: null,
            captchaError: false,
            success: false,
            countdownProgress: 100,
            countdownInterval: null
        }
    },
    methods: {
        /*  generateCaptcha() {
             const num1 = Math.floor(Math.random() * 10) + 1;
             const num2 = Math.floor(Math.random() * 10) + 1;
             const operators = ['+', '-', '*'];
             const operator = operators[Math.floor(Math.random() * operators.length)];
 
             let solution;
             switch (operator) {
                 case '+': solution = num1 + num2; break;
                 case '-': solution = num1 - num2; break;
                 case '*': solution = num1 * num2; break;
             }
 
             return {
                 question: `${num1} ${operator} ${num2} = ?`,
                 solution: solution
             };
         }, */
        generateCaptcha() {
            // Generar dos números positivos entre 1 y 9
            const num1 = Math.floor(Math.random() * 9) + 1;
            const num2 = Math.floor(Math.random() * 9) + 1;

            const operators = ['+', '*'];
            const operator = operators[Math.floor(Math.random() * operators.length)];

            // Calcular solución (siempre positiva)
            let solution;
            if (operator === '+') {
                solution = num1 + num2;
            } else {
                solution = num1 * num2;
            }

            // Para hacerlo más fácil, si la multiplicación es > 20, la convertimos en suma
            if (operator === '*' && solution > 20) {
                return {
                    question: `${num1} + ${num2} = ?`,
                    solution: num1 + num2
                };
            }

            return {
                question: `${num1} ${operator} ${num2} = ?`,
                solution: solution
            };
        },
        startCountdown() {
            const duration = 5000 * 2;
            const interval = 50;
            const steps = duration / interval;
            let step = 0;

            this.countdownProgress = 100;

            this.countdownInterval = setInterval(() => {
                step++;
                this.countdownProgress = 100 - (step / steps * 100);

                if (step >= steps) {
                    clearInterval(this.countdownInterval);
                    this.$router.back();
                }
            }, interval);
        },
        async submitForm() {
            const form = document.querySelector('.needs-validation');
            if (form.checkValidity() === false) {
                event.preventDefault();
                event.stopPropagation();
            } else {
                // Mostrar CAPTCHA antes de enviar
                if (!this.captchaVerified) {
                    this.showCaptcha = true;
                    window.scrollTo({
                        top: document.body.scrollHeight,
                        behavior: 'smooth'
                    });
                    return;
                }
                console.log("submitForm")
                let response = await api.postRegisterNewUser(this.userData);                
                if (response["status-code"] === '201' || response["status-code"] === '200') {
                    this.success = true;
                    this.startCountdown();
                }
                else {
                    window.alert("Error al crear el usuario.");
                }
            }
            form.classList.add('was-validated');
        },
        async verifyCaptcha() {
            if (!this.captchaAnswer) return;
            if (parseInt(this.captchaAnswer) === this.captchaSolution) {
                this.captchaVerified = true;
                this.showCaptcha = false;
                this.captchaError = false;               
                let response = await api.postRegisterNewUser(this.userData);               
                if (response["status-code"] == '201' || response["status-code"] == '200') {
                    this.success = true;
                    this.startCountdown();
                }
                else {
                    window.alert("Error al crear el usuario.");
                }
            } else {
                this.captchaError = true;
                // Generar nueva pregunta
                const { question, solution } = this.generateCaptcha();
                this.captchaQuestion = question;
                this.captchaSolution = solution;
                this.captchaAnswer = null;

                // Enfocar el input automáticamente
                this.$nextTick(() => {
                    const input = this.$el.querySelector('input[type="number"]');
                    if (input) input.focus();
                });
            }
        }
    },
    beforeUnmount() {
        if (this.countdownInterval) {
            clearInterval(this.countdownInterval);
        }
    }
}
</script>

<style scoped>
.user-form-container {
    min-height: 100vh;
    background-color: #f8f9fa;
}

.form-content {
    min-height: calc(100vh - 60px);
    overflow-y: auto;
}

.position-absolute {
    top: 1rem;
}

/* Responsive adjustments */
@media (max-width: 768px) {

    .form-control-lg,
    .form-select-lg {
        font-size: 1rem;
        padding: 0.5rem 1rem;
    }

    .btn-lg {
        padding: 0.5rem 1rem;
        font-size: 1rem;
    }
}

@media (min-width: 992px) {
    .form-content {
        padding-top: 2rem;
        padding-bottom: 2rem;
    }
}
</style>